export enum GTM_EVENT_CATEGORY {
  DONATION = 'DONATION',
  NEWSLETTER = 'NEWSLETTER',
  VENDOR_CLICK = 'VENDOR_CLICK',
  DISTRIBUTION = 'DISTRIBUTION',
  QUERY_LOCATION = 'QUERY_LOCATION',
  LOCATION_ACTIONS = 'LOCATION_ACTIONS',
  EVENT_CLICKTHROUGH = 'EVENT_CLICKTHROUGH',
  HERO_DONATION = 'HERO_DONATION',
  PARTNER_CLICKTHROUGH = 'PARTNER_CLICKTHROUGH',
  SUPPORT_US = 'SUPPORT_US',
}
